/**
 * Srdiečková mapová platňa — konfigurátor
 * -----------------------------------------
 * - Interaktívna mapa vľavo s vodítkom v tvare srdca (len vizuálny návod)
 * - Náhľad vpravo: fotka dubovej dosky + mapa orezaná do srdca (CSS clip-path,
 *   žiadny canvas, žiadne CORS komplikácie) + živo sa aktualizujúce texty
 * - Veľkosť A5/A4/A3 (rovnaký pomer strán, mení sa len cieľové rozlíšenie
 *   pre produkciu — uložené ako vlastnosť objednávky)
 * - Finálny vysokorozlíšený súbor na tlač (transparentné pozadie) sa generuje
 *   mimo prehliadača, z uložených parametrov (viď PRODUKCIA.md)
 */

const HP_MAP_STYLES = {
  classic: [],
  minimalist: [
    { elementType: "geometry", stylers: [{ color: "#f5f5f2" }] },
    { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
    { elementType: "labels.text.fill", stylers: [{ color: "#616161" }] },
    { featureType: "water", elementType: "geometry", stylers: [{ color: "#c9d9d3" }] },
    { featureType: "road", elementType: "geometry", stylers: [{ color: "#ffffff" }] },
    { featureType: "poi", stylers: [{ visibility: "off" }] },
    { featureType: "transit", stylers: [{ visibility: "off" }] }
  ],
  night: [
    { elementType: "geometry", stylers: [{ color: "#212121" }] },
    { elementType: "labels.text.fill", stylers: [{ color: "#9e9e9e" }] },
    { elementType: "labels.text.stroke", stylers: [{ color: "#212121" }] },
    { featureType: "water", elementType: "geometry", stylers: [{ color: "#000000" }] },
    { featureType: "road", elementType: "geometry", stylers: [{ color: "#383838" }] },
    { featureType: "poi", stylers: [{ visibility: "off" }] }
  ]
};

let hpMap;
let hpStyleKey = "classic";
let hpAddress = "";
let hpSize = "A4";
let hpAddressMarker = null;
let hpGeocoder = null;

// Normalizovany (0..1) SVG path srdca — z Marianovho navrhu Srdce_Machove_cervene_obvod.svg
const HP_HEART_PATH = "M 0.00000,0.29232 C -0.00001,0.33431 0.01190,0.38646 0.02331,0.42221 C 0.03568,0.46093 0.05182,0.49552 0.07047,0.52642 C 0.08023,0.54258 0.08910,0.55813 0.09968,0.57300 L 0.14747,0.63804 C 0.15359,0.64523 0.15859,0.65188 0.16446,0.65886 C 0.17041,0.66594 0.17579,0.67253 0.18189,0.67920 L 0.25405,0.75732 C 0.25691,0.76030 0.25964,0.76455 0.26267,0.76761 C 0.26600,0.77097 0.26907,0.77303 0.27223,0.77687 C 0.29484,0.80435 0.32395,0.82882 0.34636,0.85294 L 0.39451,0.89914 C 0.39775,0.90197 0.40075,0.90571 0.40378,0.90868 C 0.41980,0.92442 0.44721,0.94894 0.46103,0.96381 C 0.46429,0.96732 0.46703,0.96906 0.47067,0.97304 L 0.48985,0.99160 C 0.49285,0.99434 0.49613,0.99827 0.49965,1.00000 C 0.50261,0.99868 0.50579,0.99589 0.50783,0.99388 L 0.75769,0.75102 C 0.76856,0.74036 0.78027,0.72617 0.79068,0.71554 L 0.86575,0.62604 C 0.88262,0.60417 0.91903,0.55175 0.93193,0.52800 C 0.93380,0.52458 0.93520,0.52205 0.93702,0.51889 C 0.94258,0.50928 0.95661,0.48216 0.96004,0.47302 C 0.97388,0.43611 0.98089,0.41885 0.98984,0.37801 L 0.99566,0.34221 C 1.00769,0.26536 0.99517,0.17968 0.95228,0.11730 C 0.93747,0.09575 0.93224,0.08999 0.91456,0.07231 C 0.87560,0.03334 0.81325,0.00000 0.74370,0.00000 C 0.65826,-0.00000 0.59894,0.02958 0.54445,0.08528 C 0.54020,0.08963 0.53725,0.09332 0.53319,0.09764 C 0.52892,0.10220 0.52608,0.10483 0.52231,0.10961 L 0.50042,0.13398 C 0.49796,0.13314 0.48037,0.11219 0.47839,0.10970 L 0.45650,0.08517 C 0.45271,0.08122 0.44776,0.07734 0.44453,0.07357 C 0.43793,0.06585 0.41556,0.04837 0.40725,0.04260 C 0.33562,-0.00717 0.23307,-0.01310 0.15384,0.02793 C 0.12709,0.04179 0.10660,0.05760 0.08507,0.07753 L 0.06858,0.09481 C 0.06152,0.10306 0.05265,0.11426 0.04674,0.12347 C 0.01382,0.17477 0.00002,0.22611 0.00000,0.29232 L 0.00000,0.29232 Z";

window.__runHeartPlaquePersonalizer = function () {
  const root = document.querySelector(".heart-plaque");
  if (!root) return;

  injectHeartClipDef();
  setupBackgroundImage(root.dataset.bgUrl);

  const mapEl = document.getElementById("hp-map-canvas");
  const searchInput = document.getElementById("hp-search-input");

  hpMap = new google.maps.Map(mapEl, {
    center: { lat: 48.9528, lng: 20.7566 },
    zoom: 14,
    styles: HP_MAP_STYLES[hpStyleKey],
    disableDefaultUI: true,
    zoomControl: true,
    gestureHandling: "greedy",
    mapTypeControl: true,
    mapTypeControlOptions: {
      style: google.maps.MapTypeControlStyle.DROPDOWN_MENU,
      mapTypeIds: ["roadmap", "satellite", "hybrid", "terrain"]
    }
  });

  addHeartGuideOverlay(mapEl);

  const autocomplete = new google.maps.places.Autocomplete(searchInput);
  autocomplete.bindTo("bounds", hpMap);
  autocomplete.addListener("place_changed", () => {
    const place = autocomplete.getPlace();
    if (!place.geometry) return;
    hpMap.setCenter(place.geometry.location);
    hpMap.setZoom(15);
    hpAddress = place.formatted_address || searchInput.value;
    placeHeartMarker(place.geometry.location);
    resetConfirmedState();
  });

  hpGeocoder = new google.maps.Geocoder();
  searchInput.addEventListener("keydown", (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      geocodeAndPlaceHeart(searchInput.value);
    }
  });

  hpMap.addListener("dragend", resetConfirmedState);
  hpMap.addListener("zoom_changed", resetConfirmedState);

  // Styl mapy (Klasicky/Minimalisticky/Nocny) — meni aj interaktivnu mapu naraz
  document.querySelectorAll(".hp-style-btn").forEach((btn) => {
    btn.addEventListener("click", () => {
      document.querySelectorAll(".hp-style-btn").forEach((b) => b.classList.remove("is-active"));
      btn.classList.add("is-active");
      hpStyleKey = btn.dataset.style;
      hpMap.setOptions({ styles: HP_MAP_STYLES[hpStyleKey] });
      resetConfirmedState();
    });
  });

  // Vyber velkosti (A5/A4/A3) — nemeni pomer stran, len cielove rozlisenie pre produkciu
  document.querySelectorAll(".hp-size-btn").forEach((btn) => {
    btn.addEventListener("click", () => {
      document.querySelectorAll(".hp-size-btn").forEach((b) => b.classList.remove("is-active"));
      btn.classList.add("is-active");
      hpSize = btn.dataset.size;
      document.getElementById("hp-prop-size").value = hpSize;
    });
  });

  // Texty sa aktualizuju zivo, bez potreby potvrdenia
  bindLiveText("hp-names", "hp-text-names", "hp-prop-names");
  bindLiveText("hp-date", "hp-text-date", "hp-prop-date");
  bindLiveText("hp-extra", "hp-text-extra", "hp-prop-extra");

  // Volba pisma — pisany (kurziva) vs tlaceny
  document.querySelectorAll(".hp-font-btn").forEach((btn) => {
    btn.addEventListener("click", () => {
      document.querySelectorAll(".hp-font-btn").forEach((b) => b.classList.remove("is-active"));
      btn.classList.add("is-active");
      const fontKey = btn.dataset.font;
      const frame = document.getElementById("hp-preview-frame");
      frame.classList.remove("hp-font-script", "hp-font-print");
      frame.classList.add(fontKey === "print" ? "hp-font-print" : "hp-font-script");
      document.getElementById("hp-prop-font").value = fontKey === "print" ? "Tlačený" : "Písaný";
    });
  });

  document.getElementById("hp-confirm-btn").addEventListener("click", () => {
    confirmHeartMap(root.dataset.apiKey);
  });

  document.getElementById("hp-zoom-btn").addEventListener("click", openHeartLightbox);
};

if (window.__googleMapsReady) {
  window.__runHeartPlaquePersonalizer();
}

/** Vlozi <defs> so SVG heart clipPath (objectBoundingBox = funguje pri lubovolnej velkosti prvku).
 *  Path pochadza z Marianovho vlastneho SVG navrhu (Srdce_Machove_cervene_obvod.svg),
 *  normalizovany na 0..1 podla presnej bounding boxu tvaru (nie podla celej A4 stranky). */
function injectHeartClipDef() {
  if (document.getElementById("hp-heart-clip")) return;
  const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  svg.setAttribute("width", "0");
  svg.setAttribute("height", "0");
  svg.style.position = "absolute";
  svg.innerHTML = `
    <defs>
      <clipPath id="hp-heart-clip" clipPathUnits="objectBoundingBox">
        <path d="${HP_HEART_PATH}" />
      </clipPath>
    </defs>`;
  document.body.appendChild(svg);
}

/** Nastavi fotku dosky ako pozadie ramca nahladu */
function setupBackgroundImage(bgUrl) {
  const frame = document.querySelector(".heart-plaque__preview-frame");
  if (!frame || !bgUrl) return;
  const img = document.createElement("img");
  img.src = bgUrl;
  img.className = "heart-plaque__bg-img";
  img.alt = "Dubová platňa";
  frame.insertBefore(img, frame.firstChild);
}

/** Dasovane srdce navyse nad interaktivnou mapou — len vodidlo, nic neoreza.
 *  Pouziva ten isty tvar ako skutocne orezanie, takze presne zodpoveda vysledku. */
function addHeartGuideOverlay(mapEl) {
  const guide = document.createElement("div");
  guide.className = "heart-plaque__map-guide";
  guide.innerHTML = `
    <svg viewBox="0 0 1 1" preserveAspectRatio="none">
      <path d="${HP_HEART_PATH}" />
    </svg>`;
  mapEl.appendChild(guide);
}

function bindLiveText(inputId, overlaySpanId, propInputId) {
  const input = document.getElementById(inputId);
  input.addEventListener("input", () => {
    let span = document.getElementById(overlaySpanId);
    if (!span) {
      span = document.createElement("div");
      span.id = overlaySpanId;
      span.className = `heart-plaque__text-overlay heart-plaque__text-${inputId.replace("hp-", "")}`;
      document.querySelector(".heart-plaque__preview-frame").appendChild(span);
    }
    span.textContent = input.value;
    document.getElementById(propInputId).value = input.value;
  });
}

function resetConfirmedState() {
  document.getElementById("hp-add-to-cart-btn").disabled = true;
  const mapImg = document.getElementById("hp-map-preview-img");
  if (mapImg) mapImg.style.display = "none";
  const pin = document.getElementById("hp-map-pin");
  if (pin) pin.style.display = "none";
  document.getElementById("hp-preview-placeholder").style.display = "flex";
}

/** Geokoduje text z vyhladavacieho policka (pouzite tlacidlom "Vyhladat"
 *  alebo klavesom Enter — na rozdiel od Autocomplete dropdownu, funguje
 *  aj ked zakaznik nevyberie ziadnu ponuku a proste zadanu adresu potvrdi). */
function geocodeAndPlaceHeart(addressText) {
  if (!addressText || !hpGeocoder) return;
  hpGeocoder.geocode({ address: addressText }, (results, status) => {
    if (status === "OK" && results[0]) {
      const location = results[0].geometry.location;
      hpMap.setCenter(location);
      hpMap.setZoom(15);
      hpAddress = results[0].formatted_address || addressText;
      placeHeartMarker(location);
      resetConfirmedState();
    } else {
      alert("Adresu sa nepodarilo nájsť, skús ju upresniť.");
    }
  });
}

/** Vykresli na interaktivnej mape srdiečkový bod presne na vyhladanej adrese.
 *  Pouziva ten isty normalizovany tvar srdca ako orezanie/vodidlo. */
function placeHeartMarker(location) {
  if (hpAddressMarker) {
    hpAddressMarker.setPosition(location);
    return;
  }
  hpAddressMarker = new google.maps.Marker({
    position: location,
    map: hpMap,
    icon: {
      path: HP_HEART_PATH,
      fillColor: "#ff6b96",
      fillOpacity: 1,
      strokeColor: "#ffffff",
      strokeWeight: 1.5,
      scale: 26,
      anchor: new google.maps.Point(0.5, 1)
    }
  });
}

function confirmHeartMap(apiKey) {
  const center = hpMap.getCenter();
  const zoom = hpMap.getZoom();
  const lat = center.lat().toFixed(6);
  const lng = center.lng().toFixed(6);

  const staticUrl = buildHeartStaticMapUrl({ lat, lng, zoom, styleKey: hpStyleKey, apiKey });

  let mapImg = document.getElementById("hp-map-preview-img");
  if (!mapImg) {
    mapImg = document.createElement("img");
    mapImg.id = "hp-map-preview-img";
    mapImg.className = "heart-plaque__map-clip";
    mapImg.alt = "Mapa v tvare srdca";
    document.querySelector(".heart-plaque__preview-frame").appendChild(mapImg);
  }
  mapImg.src = staticUrl;
  mapImg.style.display = "block";
  document.getElementById("hp-preview-placeholder").style.display = "none";

  // Srdiecko oznacujuce presnu adresu — zobrazi sa v strede orezanej mapy
  // (mapa je centrovana presne na vyhladany/potvrdeny bod)
  let pinContainer = document.getElementById("hp-map-pin");
  if (!pinContainer) {
    pinContainer = document.createElement("div");
    pinContainer.id = "hp-map-pin";
    pinContainer.className = "heart-plaque__map-pin";
    pinContainer.innerHTML = `<div class="heart-plaque__map-pin-icon"></div>`;
    document.querySelector(".heart-plaque__preview-frame").appendChild(pinContainer);
  }
  pinContainer.style.display = "block";

  document.getElementById("hp-prop-center").value = `${lat}, ${lng}`;
  document.getElementById("hp-prop-zoom").value = zoom;
  document.getElementById("hp-prop-style").value = hpStyleKey;
  document.getElementById("hp-prop-address").value = hpAddress || `${lat}, ${lng}`;
  document.getElementById("hp-prop-preview-url").value = staticUrl;

  document.getElementById("hp-add-to-cart-btn").disabled = false;
}

function buildHeartStaticMapUrl({ lat, lng, zoom, styleKey, apiKey }) {
  const params = new URLSearchParams({
    center: `${lat},${lng}`,
    zoom: zoom,
    size: "640x640",
    scale: "2",
    key: apiKey
  });
  HP_MAP_STYLES[styleKey].forEach((rule) => {
    params.append("style", encodeHeartStyleRule(rule));
  });
  return `https://maps.googleapis.com/maps/api/staticmap?${params.toString()}`;
}

function encodeHeartStyleRule(rule) {
  const parts = [];
  if (rule.featureType) parts.push(`feature:${rule.featureType}`);
  if (rule.elementType) parts.push(`element:${rule.elementType}`);
  rule.stylers.forEach((s) => {
    Object.entries(s).forEach(([k, v]) => {
      const value = typeof v === "string" ? v.replace("#", "0x") : v;
      parts.push(`${k}:${value}`);
    });
  });
  return parts.join("|");
}

/** Otvori zvacseny nahlad platne — klonuje aktualny vizualny obsah ramca
 *  (pozadie + orezana mapa + texty) do vacsieho lightboxu. Odstranuje id
 *  z klonu, aby nekolidovali s originalom. */
function openHeartLightbox() {
  const frame = document.querySelector(".heart-plaque__preview-frame");
  if (!frame) return;

  const overlay = document.createElement("div");
  overlay.className = "hp-lightbox-overlay";

  const box = document.createElement("div");
  box.className = "hp-lightbox-frame";

  const inner = document.createElement("div");
  inner.className = "hp-lightbox-inner";
  inner.innerHTML = frame.innerHTML;
  inner.querySelectorAll("[id]").forEach((el) => el.removeAttribute("id"));
  const nestedZoomBtn = inner.querySelector(".heart-plaque__zoom-btn");
  if (nestedZoomBtn) nestedZoomBtn.remove();
  box.appendChild(inner);

  // Ovladanie priblizenia (+/-) — umoznuje detailnejsie preskumat mapu v srdci
  let scale = 1;
  const applyScale = () => {
    inner.style.transform = `scale(${scale})`;
  };
  const zoomControls = document.createElement("div");
  zoomControls.className = "hp-lightbox-zoom-controls";
  const zoomInBtn = document.createElement("button");
  zoomInBtn.type = "button";
  zoomInBtn.className = "hp-lightbox-zoom-btn";
  zoomInBtn.textContent = "+";
  zoomInBtn.addEventListener("click", () => {
    scale = Math.min(scale + 0.4, 3);
    applyScale();
  });
  const zoomOutBtn = document.createElement("button");
  zoomOutBtn.type = "button";
  zoomOutBtn.className = "hp-lightbox-zoom-btn";
  zoomOutBtn.textContent = "−";
  zoomOutBtn.addEventListener("click", () => {
    scale = Math.max(scale - 0.4, 1);
    applyScale();
  });
  zoomControls.appendChild(zoomOutBtn);
  zoomControls.appendChild(zoomInBtn);
  box.appendChild(zoomControls);

  // Kolieskom mysi tiez priblizuje/oddialuje
  box.addEventListener("wheel", (e) => {
    e.preventDefault();
    scale = Math.min(Math.max(scale - e.deltaY * 0.001, 1), 3);
    applyScale();
  }, { passive: false });

  const closeBtn = document.createElement("button");
  closeBtn.className = "hp-lightbox-close";
  closeBtn.textContent = "✕";
  closeBtn.setAttribute("aria-label", "Zavrieť");
  closeBtn.addEventListener("click", () => overlay.remove());

  overlay.addEventListener("click", (e) => {
    if (e.target === overlay) overlay.remove();
  });

  box.appendChild(closeBtn);
  overlay.appendChild(box);
  document.body.appendChild(overlay);
}